// extracted by mini-css-extract-plugin
export var container = "styles-module--container--903fb";
export var frame = "styles-module--frame--8aa89";